import { useSyncExternalStore } from 'react';

/**
 * What the compact article header shows while a story is open:
 *   { sectionLabel, sectionTo, title, scrolled, onShare, whatsappHref }
 * The article page sets it; the header reads it. null on every other page.
 */
let state = null;
const listeners = new Set();

export function setArticleHeader(next) {
  state = typeof next === 'function' ? next(state) : next;
  listeners.forEach((listener) => listener());
}

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export function useArticleHeader() {
  return useSyncExternalStore(subscribe, () => state);
}
